import type { Section } from "../types";
import { elevatorStarterKit } from "./products/elevatorStarterKit";
import { g2StarterKit } from "./products/g2StarterKit";
import { g2StarterKitPro } from "./products/g2StarterKitPro";
import { g3StarterKit } from "./products/g3StarterKit";
import { g3StarterKitPro } from "./products/g3StarterKitPro";
import { gateAccessStarterKit } from "./products/gateAccessStarterKit";
import { touchPassSupport } from "./properties";
import { includedAccessories } from "./properties/includedAccessories";
import { includedHub } from "./properties/includedHub";
import { includedReaders } from "./properties/includedReaders";

export const StarterKits: Section = {
  properties: [
    includedHub,
    includedReaders,
    includedAccessories,
    touchPassSupport,
  ],
  products: [
    g3StarterKitPro,
    g3StarterKit,
    g2StarterKitPro,
    g2StarterKit,
    elevatorStarterKit,
    gateAccessStarterKit,
  ],
  columnWidth: 339,
  propertyColumnWidth: 167 + 10,
  showBadges: true,
};
